// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__nKFZ6","requiredAsterisk":"Info_requiredAsterisk__2u0iM"};